export default "__VITE_ASSET__Ao6OsbAV__"